/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getState as getLiveCaptionsState } from "../../../../live-caption/functions";
import { addCaption } from "../../../../live-caption/slice";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../../../../notifications";
import { getUserIdByOccupantId } from "../../../../base/participants";
import { makeStyles } from "tss-react/mui";
import { isMenuOpen } from "../../../../base/util/functions";
import { Box, Typography } from "@mui/material";
import Avatar from "../../../../base/avatar/components/Avatar";
import moment from "moment";
var recognition;
const useStyles = makeStyles()(theme => {
    return {
        liveCaptionsContainer: {
            position: 'fixed',
            zIndex: 11,
            overflowY: 'auto',
            transition: 'all 1s',
            maxHeight: 300,
            borderRadius: 8,
            backgroundColor: '#000000B8',
            bottom: 100,
            padding: '12px 18px',
            left: 20,
            right: 20,
            '@media (min-width: 720px)': {
                left: '10%',
                right: '10%',
                maxWidth: 644
            },
            '@media (min-width: 1345px)': {
                left: '20%',
                right: '20%',
                maxWidth: 644
            },
            '@media (min-width: 1555px)': {
                left: '50%',
                transform: 'translateX(-50%)',
                maxWidth: 644
            }
        },
        menuOpen: {
            display: 'none',
            '@media (min-width: 1345px)': {
                display: 'block'
            }
        },
        liveCaptionItem: {
            display: 'flex'
        },
        captionLabel: {
            color: '#949595',
            textAlign: 'left',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: '18px'
        },
        captionContent: {
            fontSize: 18,
            color: '#FFF',
            lineHeight: '27px',
            textAlign: 'left'
        }
    };
});
export default function LiveCaptions() {
    const { cx, classes } = useStyles();
    const menuOpen = useSelector((state) => isMenuOpen(state));
    const [showWarningStreamAudio, setShowWarningStreamAudio] = useState(false);
    const dispatch = useDispatch();
    const { local } = useSelector((state) => state['features/base/participants']);
    const { roomInfo } = useSelector((state) => state['features/base/conference']);
    const { enableSubtitle } = useSelector((state) => state['features/subtitles']);
    const { enabled, streamStatus, visibleCaptions, languageTranscription, pushLayoutUser } = useSelector(getLiveCaptionsState);
    const roomId = roomInfo?.roomId;
    const userId = useSelector((state) => getUserIdByOccupantId(state, state['features/base/participants'].local?.id || ""));
    const { audio } = useSelector((state) => state['features/base/media']);
    const [currentOffset, setCurrentOffset] = useState(undefined);
    let textId = `${userId}_${generateRandomString()}`;
    let ordinalNumber = 0;
    let recentTranscripts = [];
    let interim_transcript = "";
    const liveRef = useRef(null);
    const { showPrejoin: isInPrejoin } = useSelector((state) => state["features/prejoin"]);
    function generateRandomString() {
        const characters = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        return Array.from({ length: 10 }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join("");
    }
    function restartSpeechAPI() {
        setTimeout(() => {
            if (APP.store.getState()['features/subtitles'].enableSubtitle && audio.muted) {
                try {
                    recognition?.start();
                    setTimeout(() => {
                        recognition.retryCount = 0;
                    }, 50);
                }
                catch (error) {
                    // console.log("restartSpeechAPI: error:", error);
                }
            }
        }, 200);
    }
    useEffect(() => {
        // Sử dụng Web Speech API
        const SpeechRecognition = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
        if (!SpeechRecognition) {
            console.error("Speech Recognition API is not supported in this browser.");
        }
        else {
            recognition = new SpeechRecognition();
            recognition.lang = "vi-VI";
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.onerror = (event) => {
                // console.error("Recognition error:", event?.error);
                restartSpeechAPI();
            };
            recognition.onend = (event) => {
                // console.error("Recognition onend:", event?.onend);
                restartSpeechAPI();
            };
            recognition.onresult = (event) => {
                // Create the interim transcript string locally because we don't want it to persist like final transcript
                const userName = local?.name;
                interim_transcript = "";
                // Loop through the results from the speech recognition object.
                for (let i = event.resultIndex; i < event.results.length; ++i) {
                    // If the result item is Final, add it to Final Transcript, Else add it to Interim transcript
                    if (event.results[i].isFinal) {
                        textId = userId + "_" + generateRandomString();
                    }
                    else {
                        interim_transcript += event.results[i]?.[0]?.transcript;
                    }
                }
                if (interim_transcript.length > 0 && shouldEmitTranscript(interim_transcript)) {
                    // Nếu khác, gửi qua WebSocket
                    let data_transcript = {
                        ordinal_number: ordinalNumber,
                        room_id: roomId,
                        text_id: textId,
                        user_id: userId,
                        socket_id: webSocket.id,
                        user_name: userName,
                        text_transcript: interim_transcript.trimStart(),
                        is_final: false,
                        participant_id: local?.id
                    };
                    ordinalNumber += 1;
                    webSocket.emit("text_transcript_client", data_transcript);
                }
            };
        }
    }, [isInPrejoin]);
    useEffect(() => {
        if (recognition) {
            recognition.lang = languageTranscription;
            if (audio.muted) {
                try {
                    recognition?.stop();
                }
                catch (error) {
                    // console.log("speechRecognition start: " + error);
                }
            }
            else {
                // console.log("===> streamStatus: stopped");
            }
        }
    }, [languageTranscription, audio.muted]);
    useEffect(() => {
        if (enabled) {
            webSocket.on('text_transcript_server', (data) => {
                dispatch(addCaption(data));
                if (data?.is_final && data.user_name !== local?.name) {
                    textId = `${userId}_${generateRandomString()}`;
                    interim_transcript = "";
                }
            });
        }
        else {
            webSocket.off('text_transcript_server');
        }
    }, [enabled, pushLayoutUser]);
    useEffect(() => {
        localStorage.setItem("liveCaptionStatus", streamStatus);
        if (enableSubtitle) {
            if (!audio.muted) {
                try {
                    recognition?.start();
                }
                catch (error) {
                    // console.log("speechRecognition start: " + error);
                }
            }
            else {
                try {
                    recognition?.stop();
                }
                catch (error) {
                    // console.log("speechRecognition stop: " + error);
                }
            }
            // cảnh báo người dùng - chỉ cảnh báo khi bật mic lần đầu tiên
            if (local?.id !== "local" && audio.muted && !showWarningStreamAudio) {
                dispatch(showNotification({
                    titleKey: 'notify.warningStreamAudioLiveCaptionTitle',
                    descriptionKey: 'notify.warningStreamAudioLiveCaptionDescription'
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                setShowWarningStreamAudio(true);
            }
        }
    }, [enableSubtitle, audio.muted]);
    // useEffect(() => {
    //     if (enableSubtitle && !audio.muted) {
    //         try {
    //             recognition?.start();
    //         } catch (error) {
    //             console.log("enableSubtitle: " + error);
    //         }
    //         // cảnh báo người dùng - chỉ cảnh báo khi bật mic lần đầu tiên
    //         if (local?.id !== "local" && !showWarningStreamAudio) {
    //             dispatch(showNotification({
    //                 titleKey: 'notify.warningStreamAudioLiveCaptionTitle',
    //                 descriptionKey: 'notify.warningStreamAudioLiveCaptionDescription'
    //             }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    //             setShowWarningStreamAudio(true);
    //         }
    //     } else {
    //     }
    // }, [enableSubtitle, audio.muted]);
    function shouldEmitTranscript(transcript) {
        if (!recentTranscripts.includes(transcript)) {
            recentTranscripts.push(transcript);
            if (recentTranscripts.length > 10) {
                recentTranscripts.shift();
            }
            return true;
        }
        return false;
    }
    useEffect(() => {
        if (liveRef.current) {
            const observer = new ResizeObserver(() => {
                if (liveRef.current?.childNodes) {
                    const totalHeight = Array.from(liveRef.current.childNodes).reduce((total, node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const element = node;
                            return total + element.offsetHeight;
                        }
                        return total;
                    }, 0);
                    if (totalHeight > 300 && currentOffset === undefined) {
                        liveRef.current.scrollTo({
                            top: totalHeight,
                            behavior: 'smooth'
                        });
                    }
                }
            });
            observer.observe(liveRef.current, {});
        }
        liveRef.current?.addEventListener('scroll', () => {
            if (liveRef.current) {
                const totalHeight = Array.from(liveRef.current.childNodes).reduce((total, node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const element = node;
                        return total + element.offsetHeight;
                    }
                    return total;
                }, 0);
                setCurrentOffset(totalHeight - liveRef.current?.scrollTop === 300 ? undefined : liveRef.current?.scrollTop);
            }
        });
        return () => {
        };
    }, [liveRef.current, liveRef.current?.lastElementChild, visibleCaptions]);
    return (React.createElement(React.Fragment, null, Boolean(visibleCaptions.length > 0) && streamStatus === 'started' ? React.createElement("div", { ref: liveRef, className: cx(classes.liveCaptionsContainer, menuOpen && classes.menuOpen) }, visibleCaptions && Array.isArray(visibleCaptions) &&
        visibleCaptions.map((caption) => {
            return (React.createElement("div", { key: caption?.text_id, className: cx(classes.liveCaptionItem) },
                React.createElement(Box, { sx: { marginTop: '6px' } },
                    React.createElement(Avatar, { size: 24, participantId: caption?.participant_id, className: "avatar-live-captions" })),
                React.createElement(Box, { sx: { marginLeft: '1rem' } },
                    React.createElement(Typography, { className: cx(classes.captionLabel) }, `${caption.user_name} ${caption?.speaker_time ? moment.unix(caption.speaker_time).format("HH:mm") : moment().format("HH:mm")}`),
                    React.createElement(Typography, { className: cx(classes.captionContent) }, caption.text_transcript))));
        })) : React.createElement(React.Fragment, null)));
}
